/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, put, takeLatest } from 'redux-saga/effects';
import { passkeyRegister } from '../api';
import {
  passkeyRegisterFailed,
  passkeyRegisterOtpRequired,
  passkeyRegisterRequest,
  passkeyRegisterSuccess,
} from '../reducer/passkeyRegisterSlice';
import { getPasskeyOtpStepUp } from '../utils/passkeyList';

export function* passkeyRegisterSaga(
  action: any
): Generator<any, void, unknown> {
  const { apiName, data } = action.payload;
  const requestData = {
    ...data,
    username: String(data?.username ?? '').trim().toLowerCase(),
  };
  try {
    const response: any = yield call(passkeyRegister, apiName, requestData);
    const otpStepUp = getPasskeyOtpStepUp(response);
    if (otpStepUp.required && otpStepUp.passkeyToken) {
      yield put(
        passkeyRegisterOtpRequired({ passkeyToken: otpStepUp.passkeyToken })
      );
      return;
    }

    const isSuccessStatus =
      response?.status === 200 ||
      response?.status === '200' ||
      response?.status == null;
    const userId = response?.result?.user_id;

    if (isSuccessStatus && userId) {
      yield put(passkeyRegisterSuccess(response.result));
    } else {
      const { status, detail, errorCode } = response ?? {};
      yield put(
        passkeyRegisterFailed({
          statusCode: status ?? '500',
          error: {
            errCode: errorCode ? errorCode : 'UNKNOWN_ERROR',
            msg: detail ?? 'An unknown error occurred.',
            statusCode: status ?? '500',
          },
        })
      );
    }
  } catch (error: any) {
    const otpStepUp = getPasskeyOtpStepUp(error);
    if (otpStepUp.required && otpStepUp.passkeyToken) {
      yield put(
        passkeyRegisterOtpRequired({ passkeyToken: otpStepUp.passkeyToken })
      );
      return;
    }
    const {
      status = '500',
      errorCode = 'UNKNOWN_ERROR',
      detail = 'An unknown error occurred.',
    } = error?.data ?? error ?? {};
    yield put(
      passkeyRegisterFailed({
        statusCode: status,
        error: {
          errCode: errorCode,
          msg: detail,
        },
      })
    );
  }
}

export function* watchPasskeyRegisterSaga() {
  yield takeLatest(passkeyRegisterRequest.type, passkeyRegisterSaga);
}
